import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import NavCommon from "../../components/@navHeader";
import { PerfilComponent } from "./perfil/perfil.component";

const ParentContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  margin-top: 80px;
  width: 100%;
  padding: 32px;
  box-sizing: border-box;

  h3 {
    font-size: 24px;
    font-family: Inter;
    font-weight: 400;
    padding: 10px 0px;
  }
`;

export function PerfilAutonomo() {
  const history = useHistory();

  return (
    <>
      <NavCommon
        breadcrumbs={[{ path: "/profile", name: "Perfil" }]}
        showButtonNew
        onBack={() => {
          history.goBack();
        }}
        open
        onChangeActionNew={undefined}
      />
      <ParentContainer>
        <h3>Perfil</h3>
        <PerfilComponent />
      </ParentContainer>
    </>
  );
}
